import { Directive, inject, TemplateRef } from "@angular/core";
import { LgPanelContext } from "../service";

@Directive({
    selector: "[lgPanelBody]"
})
export class LgPanelBodyDirective {
    _bodyTemplate = inject(TemplateRef<LgPanelContext>);
}
